import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import Config from 'arbitrip-common/client/utils/Config';

class CombtasContainer extends React.Component {
	render() {
		const { t } = this.props;
		let { combtasId, reservationData, shouldLockForm, onCombtasIdChange } = this.props;

		return (
			<div className="combtas-id-container">
				<label htmlFor="combtas_id">{t('TASID')}</label>
				<input
					type="text"
					className="form-control"
					id="combtas_id"
					value={combtasId}
					disabled={shouldLockForm}
					onChange={onCombtasIdChange}
					placeholder={t('TASIDPlaceholder')}
					maxLength="10"
				/>
				{Config.dev_mode && reservationData.proposal_id ? (
					<span>
						({t('ProposalID')} = {reservationData.proposal_id})
					</span>
				) : null}
			</div>
		);
	}
}

CombtasContainer.propTypes = {
	reservationData: PropTypes.any.isRequired,
	combtasId: PropTypes.string.isRequired,
	shouldLockForm: PropTypes.bool.isRequired,
	onCombtasIdChange: PropTypes.func.isRequired,
};

export default withTranslation()(CombtasContainer);
